import { Component } from '@theme/component';
import { WISHLIST_STORAGE_KEY, WishlistEvents, getWishlistCount } from '@theme/wishlist';

/**
 * Header wishlist icon with a live count bubble. Mirrors the cart-icon pattern:
 * listens for same-tab wishlist updates and cross-tab `storage` events.
 *
 * Markup lives in `snippets/header-actions.liquid`.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} count - The bubble count element.
 * @extends {Component<Refs>}
 */
class WishlistIcon extends Component {
  requiredRefs = ['count'];

  connectedCallback() {
    super.connectedCallback();
    this.#render();
    document.addEventListener(WishlistEvents.update, this.#onUpdate);
    window.addEventListener('storage', this.#onStorage);
    window.addEventListener('pageshow', this.#onUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(WishlistEvents.update, this.#onUpdate);
    window.removeEventListener('storage', this.#onStorage);
    window.removeEventListener('pageshow', this.#onUpdate);
  }

  #onUpdate = () => this.#render();

  /** @param {StorageEvent} event */
  #onStorage = (event) => {
    if (event.key === WISHLIST_STORAGE_KEY || event.key == null) this.#render();
  };

  #render() {
    const count = getWishlistCount();
    this.refs.count.textContent = count > 0 ? String(count) : '';
    this.classList.toggle('wishlist-icon--has-items', count > 0);
  }
}

if (!customElements.get('wishlist-icon')) {
  customElements.define('wishlist-icon', WishlistIcon);
}
